const ButtonComponent = videojs.getComponent('Button');
let localize;

// This is an invisible button to the left of the play button on the control bar that allows people using screen readers to prevent
//  the control bar from auto-hiding after the configured inactivity timeout (2 seconds by default).
export class ControlsLockButton extends ButtonComponent {
    constructor(player, options = {}) {
        localize = player.localize?.bind(player);
        const keepFocus = localize('Controls will remain in focus');
        const willAutoHide = localize('Controls will auto-hide');

        options.clickHandler = () => {
            this.controlsAreLocked = !this.controlsAreLocked;
            this.activeText = this.controlsAreLocked ? keepFocus : willAutoHide;
            this.el().setAttribute('aria-pressed', this.controlsAreLocked);

            this.registerChange();
            // Delay the announcement so it says "pressed" first (on NVDA at least)
            setTimeout(this.announceButtonClick.bind(this), 100);

            if (player.paused() && !this.listeningForPlayEvent) {
                // Changes don't register properly when paused, so change the timeout when the player starts again
                this.listeningForPlayEvent = true;
                player.one('playing', () => {
                    this.registerChange();
                });
            }
        };

        super(player, Object.assign({ name: 'ControlsLockButton' }, options));

        this.configuredTimeout = player.options_.inactivityTimeout;
        this.controlsAreLocked = false;
        this.listeningForPlayEvent = false;

        this.addClass('mediasite-player__custom-controlbar-button');
        this.addClass('mediasite-player__controls-lock-button');
        this.addClass('sr-only');

        this.controlText(localize(`Keep control bar in focus (L)`));

        this.player = player;
    }

    registerChange() {
        // Changing the inactivity timeout to 0 prevents the control bar from fading.
        this.player.options_.inactivityTimeout = this.controlsAreLocked ? 0 : this.configuredTimeout;
        this.player.cache_.inactivityTimeout = this.player.options_.inactivityTimeout;
        this.player.userActive(true);
        this.player.reportUserActivity();
        // Clear the play listener
        this.listeningForPlayEvent = false;
    }
}